import React, { useState } from 'react';
import Modal from 'react-modal';
import * as XLSX from 'xlsx';
import { DownloadIcon, AdjustmentsIcon } from '@heroicons/react/solid';
import { ExcelExport } from '../services/exportData';
import "./ExcelFilter.css"

Modal.setAppElement('#root');

const ExcelFilter = ({ users }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [startDay, setStartDay] = useState('');
  const [endDay, setEndDay] = useState('');
  const [dataLoading, setDataLoading] = useState(false);
  const [excelStarted, exportExcelStarted] = useState(false);


  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  // const exportToExcel = async () => {
  //   setDataLoading(true);

  //   try {

  //     const data = await ExcelExport(startDay, endDay);
  //     console.log('Fetched data:', data);

  //     if (data && Array.isArray(data)) {
  //       const worksheet = XLSX.utils.json_to_sheet(data);
  //       const workbook = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(workbook, worksheet, 'User Data');

  //       XLSX.writeFile(workbook, 'User_Data.xlsx');
  //     } else {
  //       console.error('Unexpected data format:', data);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data for export:', error);
  //   } finally {
  //     setDataLoading(false);
  //     closeModal();
  //   }
  // };

  const exportToExcel = async () => {
    setDataLoading(true);
    try {
      const userDataBySheet = await ExcelExport(startDay, endDay);
      console.log('Fetched data for sheets:', userDataBySheet);

      const workbook = XLSX.utils.book_new();

      const allRows = [];
      const finalHeader = new Set();

      const staticHeaders = ['SiNo', 'UserID', 'Group', 'DailyGoal', 'GoalDate'];
      const dynamicFields = ['Day', 'DayDate', 'DailySteps', 'CumulativeBalance', 'Feedback1', 'Feedback2', 'Feedback3', 'FreshStartDates'];

      const headerRow = [...staticHeaders];

      // Find the max number of dynamic entries (days) to build full header
      let maxEntries = 0;
      for (const userId in userDataBySheet) {
        if (userDataBySheet.hasOwnProperty(userId)) {
          const userData = userDataBySheet[userId];
          if (userData && userData.length > maxEntries) {
            maxEntries = userData.length;
          }
        }
      }

      // Build header with max columns
      for (let i = 1; i <= maxEntries; i++) {
        dynamicFields.forEach((field) => {
          headerRow.push(`${field}`);
        });
      }

      allRows.push(headerRow);

      // Now build rows per user
      for (const userId in userDataBySheet) {
        if (userDataBySheet.hasOwnProperty(userId)) {
          const userData = userDataBySheet[userId];
          if (!userData || userData.length === 0) continue;

          const { SiNo, UserID, Group, DailyGoal, GoalDate } = userData[0];
          const staticValues = [SiNo, UserID, Group, DailyGoal, GoalDate];
          const row = [...staticValues];

          userData.forEach((entry) => {
            dynamicFields.forEach((field) => {
              row.push(entry[field] || '');
            });
          });

          // Fill missing dynamic values if current user has fewer entries
          const expectedLength = staticHeaders.length + (maxEntries * dynamicFields.length);
          while (row.length < expectedLength) {
            row.push('');
          }

          allRows.push(row);
        }
      }

      const worksheet = XLSX.utils.aoa_to_sheet(allRows);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'All Users');

      XLSX.writeFile(workbook, 'User_Data.xlsx');
    } catch (error) {
      console.error('Error exporting data:', error);
    } finally {
      setDataLoading(false);
      closeModal();
    }
  };


  // const exportToExcelAll = async () => {
  //   exportExcelStarted(true);
  //   try {
  //     const data = await ExcelExport('',''); 
  //     console.log('Fetched data:', data); 

  //     if (data && Array.isArray(data)) {
  //       const worksheet = XLSX.utils.json_to_sheet(data);
  //       const workbook = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(workbook, worksheet, 'User Data');

  //       XLSX.writeFile(workbook, 'User_Data.xlsx');
  //     } else {
  //       console.error('Unexpected data format:', data);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data for export:', error);
  //   } finally {
  //     exportExcelStarted(false);
  //     closeModal(); 
  //   }
  // };

  const exportToExcelAll = async () => {
    exportExcelStarted(true);
    try {
      const userDataBySheet = await ExcelExport('', '');
      console.log('Fetched data for sheets:', userDataBySheet);

      const workbook = XLSX.utils.book_new();

      const allRows = [];
      const finalHeader = new Set();

      const staticHeaders = ['SiNo', 'UserID', 'Group', 'DailyGoal', 'GoalDate'];
      const dynamicFields = ['Day', 'DayDate', 'DailySteps', 'CumulativeBalance', 'Feedback1', 'Feedback2', 'Feedback3', 'FreshStartDates'];

      const headerRow = [...staticHeaders];

      // Find the max number of dynamic entries (days) to build full header
      let maxEntries = 0;
      for (const userId in userDataBySheet) {
        if (userDataBySheet.hasOwnProperty(userId)) {
          const userData = userDataBySheet[userId];
          if (userData && userData.length > maxEntries) {
            maxEntries = userData.length;
          }
        }
      }

      // Build header with max columns
      for (let i = 1; i <= maxEntries; i++) {
        dynamicFields.forEach((field) => {
          headerRow.push(`${field}`);
        });
      }

      allRows.push(headerRow);

      // Now build rows per user
      for (const userId in userDataBySheet) {
        if (userDataBySheet.hasOwnProperty(userId)) {
          const userData = userDataBySheet[userId];
          if (!userData || userData.length === 0) continue;

          const { SiNo, UserID, Group, DailyGoal, GoalDate } = userData[0];
          const staticValues = [SiNo, UserID, Group, DailyGoal, GoalDate];
          const row = [...staticValues];

          userData.forEach((entry) => {
            dynamicFields.forEach((field) => {
              row.push(entry[field] || '');
            });
          });

          // Fill missing dynamic values if current user has fewer entries
          const expectedLength = staticHeaders.length + (maxEntries * dynamicFields.length);
          while (row.length < expectedLength) {
            row.push('');
          }

          allRows.push(row);
        }
      }

      const worksheet = XLSX.utils.aoa_to_sheet(allRows);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'All Users');

      XLSX.writeFile(workbook, 'User_Data.xlsx');
    } catch (error) {
      console.error('Error exporting data:', error);
    } finally {
      exportExcelStarted(false);
      closeModal();
    }
  };

  return (
    <div className="flex items-center space-x-4 mt-6">
      <button
        onClick={openModal}
        disabled={excelStarted}
        className={`flex items-center justify-center gap-2 w-40 px-4 py-2.5 
    ${excelStarted ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#900028] hover:bg-[#7a0020]'} 
    text-white text-sm font-semibold rounded-md shadow transition-all duration-200`}
      >
        <DownloadIcon className="w-5 h-5" />
        Export Filtered
      </button>

      <button
        onClick={exportToExcelAll}
        disabled={excelStarted}
        className={`flex items-center justify-center gap-2 w-40 px-4 py-2.5 
    ${excelStarted ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-600 hover:bg-gray-700'} 
    text-white text-sm font-semibold rounded-md shadow transition-all duration-200`}
      >
        <DownloadIcon className="w-5 h-5" />
        {excelStarted ? 'Exporting...' : 'Export All'}
      </button>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Filter Modal"
        className="w-full max-w-md mx-auto bg-white rounded-2xl shadow-xl p-6"
        overlayClassName="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
      >
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Select Day Range</h2>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Start Day:</label>
          <input
            type="number"
            min="1"
            max="30"
            value={startDay}
            onChange={(e) => setStartDay(e.target.value)}
            className="p-3 border border-gray-300 rounded-lg w-full focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">End Day:</label>
          <input
            type="number"
            min="1"
            max="30"
            value={endDay}
            onChange={(e) => setEndDay(e.target.value)}
            className="p-3 border border-gray-300 rounded-lg w-full focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={closeModal}
            className="px-4 py-2 text-sm bg-[#1E2D40] hover:bg-slate-600 text-white rounded-md transition duration-200"
          >
            Cancel
          </button>
          <button
            onClick={exportToExcel}
            className="px-4 py-2 text-sm bg-[#1E2D40]  text-white rounded-md transition duration-200"
            disabled={dataLoading}
          >
            {dataLoading ? 'Exporting...' : 'Export'}
          </button>
        </div>
      </Modal>
    </div>

  );
};

export default ExcelFilter;